<script>
export default {
    name: 'ServicePlanRequirement',
};
</script>

<script setup>
import { useRouter } from 'vue-router/composables';

const props = defineProps({
    pricingRoute: {
        type: Object,
    },
});

const emit = defineEmits({
    click: null,
});

const router = useRouter();

function click() {
    if (!props.pricingRoute) return;

    if (router.currentRoute.name !== props.pricingRoute.name) {
        try {
            router.push(props.pricingRoute);
        } catch (error) {
            if (error.name !== 'NavigationDuplicated') {
                throw error;
            }
        }
    }

    emit('click');
}
</script>

<template>
    <base-tooltip
        placement="top"
        :content="$t('plan feature not allowed')"
    >
        <div
            class="flex items-center gap-x-2"
            :class="{
                'cursor-pointer': pricingRoute,
                'hover:opacity-75': pricingRoute,
            }"
            @click="click"
        >
            <slot />

            <base-icon
                class="text-yellow-500"
                name="lock"
            />
        </div>
    </base-tooltip>
</template>
